//USED ONES//
export const POST_LOGIN = "/post-login"
export const POST_LOGOUT = "/process-logout"
export const POST_ADD_DEFAULT_UNITS =  "/tmsuperadmin/add-default-units"
export const POST_ADD_DEFAULT_TAXES =  "/tmsuperadmin/add-default-taxes"
export const POST_ADD_COA =  "/tmadmin/post-add-newcoa"
export const POST_ADD_PAYMENTENTRY =  "/tmadmin/post-add-paymententry"
export const POST_ADD_PURCHASE_PAYMENTENTRY =  "/tmadmin/add-payment-expense-entry"
export const POST_EDIT_COA =  "/tmadmin/post-edit-coa"
export const POST_ADD_DEFAULT_COA =  "/tmsuperadmin/add-default-coa-masters"
export const GET_MASTER_COA_LIST = "/tmadmin/get-master-coa-list"
export const POST_ADD_DEFAULT_COACC = "/tmsuperadmin/add-default-coa-accounts"
export const POST_ADD_DEFAULT_SETTINGS = "/tmsuperadmin/add-default-settings"
export const GET_COA_LIST = "/tmadmin/get-coas"
export const POST_EDIT_SETTING = "/tmadmin/edit-settings"
export const GET_STORE_DETAILS = "/tmadmin/retrieve-storedetails"
export const POST_EDIT_STORE_DETAILS =  "/tmadmin/post-edit-store-details"
export const GET_SALES_RECEIPT_LIST =  "/tmadmin/get-sales-receipt-list"
export const GET_PURCHASE_PAYMENT_LIST =  "/tmadmin/get-purchase-payment-list"
export const POST_CONFIRM_IMPORT =  "/tmsuperadmin/confirm-import-products"
export const CLEAR_ALL_CACHE =  "/tmsuperadmin/clear-all-cache"
export const GET_NEXT_PRODUCT_CODE = "/tmadmin/get-next-productcode"
export const POST_EDIT_EMP =  "/tmadmin/post-edit-employee" 
export const POST_ADD_EMP =  "/tmadmin/post-add-employee"
export const POST_ADD_BANK =  "/tmadmin/post-add-bank"
export const POST_ADD_NEW_EXPENSE =  "/tmadmin/post-add-expense"
export const POST_ADD_NEW_CASH_INPUT =  "/tmadmin/post-add-cash-input"

export const POST_GET_HOLIDAY_LIST =  "/tmadmin/get-public-holiday-list"
export const POST_ADD_NEW_HOLIDAY =  "/tmadmin/add-new-holiday"
export const POST_EDIT_PHOLIDAY =  "/tmadmin/post-edit-holiday" 
export const POST_ADD_NEW_EMPLOYEE_LEDGER =  "/tmadmin/post-add-emp-ledger" 
export const POST_GET_EMP_PAY_LEAVE_DETAILS =  "/tmadmin/post-get-emp-pay-leaves" 
export const POST_EDIT_EMP_LEAVES =  "/tmadmin/post-edit-emp-leave" 
export const POST_EDIT_EMP_PAYEMENT =  "/tmadmin/post-edit-emp-payment" 
export const POST_EDIT_BANK =  "/tmadmin/post-edit-bank" 
export const GET_EXPENSE_LIST =  "/tmadmin/get-expense-list"
export const GET_CASH_INPUT_LIST =  "/tmadmin/get-cashinput-list"
export const POST_EDIT_EXPENSE =  "/tmadmin/post-edit-expense" 
export const POST_SWITCH_STORE =  "/tmadmin/switch-store" 


export const DELETE_PAYMENT_ITEM = "/tmadmin/post-delete-payment-details"
export const DELETE_PURCHASE_PAYMENT_ITEM = "/tmadmin/post-delete-purchase-payment"

export const POST_EDIT_PAYMENT_ENTRY =  "/tmadmin/post-edit-payment-details"
export const POST_EDIT_PURCHASE_PAYMENT_ENTRY =  "/tmadmin/post-edit-purchase-payment"
export const GET_SALES_CHART_DATA = "/tmadmin/get-sales-chart"
export const GET_CUSTOMER_SALES_SUMMARY = "/tmadmin/get-customer-sales-summary"
export const GET_SUPPLIER_PURCHASE_SUMMARY = "/tmadmin/get-supplier-purchase-summary"

export const GET_DAY_REPORT = "/tmadmin/get-day-report"
export const GET_SALES_REPORT = "/tmadmin/get-sales-report"
export const GET_PROFIT_REPORT = "/tmadmin/get-profit-report"

export const POST_IMAGES = "/tmadmin/attach-images"
export const POST_IMPORT_PRODUCTS = "/tmadmin/import-products"

export const GET_CATEGORY_SUBCAT = "/tmadmin/get-category-subcat"
export const GET_HSN_LIST = "/tmadmin/get-hsn-list"
export const GET_UNIT_LIST = "/tmadmin/get-unit-list"
export const GET_MANUFACTURER_LIST = "/tmadmin/get-manufacturer-list"
export const GET_TAX_LIST = "/tmadmin/get-tax-list"
export const GET_PRODUCTS_LIST = "/tmadmin/get-product-list"
export const GET_STATE_LIST = "/tmadmin/get-state-list"

export const GET_SUPPLIER_LIST = "/tmadmin/get-supplier-list"
export const GET_BRAND_LIST = "/tmadmin/get-brand-list"
export const GET_COLOUR_LIST = "/tmadmin/get-colour-list"
export const GET_SIZE_LIST = "/tmadmin/get-size-list"
export const ADD_CATEGORY = "/tmadmin/post-add-category"
export const ADD_SUB_CATEGORY = "/tmadmin/post-add-sub-category"
export const ADD_HSN = "/tmadmin/post-add-hsn"
export const ADD_SUPPLIER = "/tmadmin/post-add-supplier"
export const ADD_BRAND = "/tmadmin/post-add-brand"
export const ADD_TAX = "/tmadmin/post-add-tax"
export const ADD_MANUFACTURER = "/tmadmin/post-add-manufacturer"
export const ADD_UNIT = "/tmadmin/post-add-unit"
export const ADD_COLOUR = "/tmadmin/post-add-colour"
export const ADD_SIZE = "/tmadmin/post-add-size"
export const ADD_PRODUCT = "/tmadmin/post-add-product"
export const GET_PRODUCT_DETAIL_FOR_EDIT = "/tmadmin/get-product-detail"
export const GET_PRODUCT_DROPDOWN = "/tmadmin/get-product-list-dd"
export const GET_STORE_SETTINGS = "/tmadmin/get-settings"
export const GET_LEDGER_DETAILS = "/tmadmin/get-ledger-details"
export const ADD_PURCHASE_ENTRY = "/tmadmin/post-add-purchase-entry"
export const ADD_PURCHASE_ENTRY_LIST = "/tmadmin/get-purchase-entry-list"
export const GET_PURCHASE_ENTRY_FOR_EDIT = "/tmadmin/edit-purchaseentry"
export const EDIT_PURCHASE_ENTRY = "/tmadmin/post-edit-purchase-entry"

export const GET_EMPLOYEE_LIST = "/tmsuperadmin/get-employee-list"
export const GET_BANK_LIST = "/tmadmin/get-bank-list"
export const GET_CUSTOMER_LIST = "/tmadmin/get-customer-list"
export const ADD_CUSTOMER = "/tmadmin/post-add-customer"
export const EDIT_CUSTOMER = "/tmadmin/post-edit-customer"
export const GET_STOCK_BALANCE = "/tmadmin/get-stock-balance"
export const GET_OTHER_UNITS = "/tmadmin/get-pdt-conversions"

export const ADD_SALES_ENTRY = "/tmadmin/post-add-sales-entry"
export const ADD_SALES_ENTRY_LIST = "/tmadmin/get-sales-entry-list"
export const GET_SALES_ENTRY_FOR_EDIT = "/tmadmin/edit-salesentry"
export const EDIT_SALES_ENTRY = "/tmadmin/post-edit-sales-entry"
export const GET_EXPENSE_DETAILS = "/tmadmin/get-expense-details"
export const EDIT_CATEGORY = "/tmadmin/post-edit-category"
export const EDIT_SUB_CATEGORY = "/tmadmin/post-edit-subcategory"
export const EDIT_HSN = "/tmadmin/post-edit-hsn"
export const EDIT_SUPPLIER = "/tmadmin/post-edit-supplier"
export const EDIT_BRAND = "/tmadmin/post-edit-brand"
export const EDIT_TAX = "/tmadmin/post-edit-tax"
export const EDIT_MANUFACTURER = "/tmadmin/post-edit-manufacturer"
export const EDIT_UNIT = "/tmadmin/post-edit-unit"
export const EDIT_COLOUR = "/tmadmin/post-edit-colour"
export const EDIT_SIZE = "/tmadmin/post-edit-size"
export const EDIT_PRODUCT = "/tmadmin/post-edit-product"

export const DELETE_ITEM = "/tmadmin/post-delete-item"
export const POST_EXTEND_SESSION = "/extend-session"

export const POST_GET_PREV_SALES = "/tmadmin/post-get-prev-sales"
export const POST_GET_NEXT_SALES = "/tmadmin/post-get-next-sales"

export const POST_GET_PREV_PURCHASE = "/tmadmin/post-get-prev-purchase"
export const POST_GET_NEXT_PURCHASE = "/tmadmin/post-get-next-purchase"
//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register"

//LOGIN
export const POST_FAKE_LOGIN = "/post-fake-login"
export const POST_FAKE_JWT_LOGIN = "/post-jwt-login"
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd"
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd"
export const SOCIAL_LOGIN = "/social-login"

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile"
export const POST_EDIT_PROFILE = "/post-fake-profile"

//PRODUCTS
export const GET_PRODUCTS = "/products"
export const GET_PRODUCTS_DETAIL = "/product"

//Mails
export const GET_INBOX_MAILS = "/inboxmails"
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail"
export const DELETE_INBOX_MAIL = "/delete/inboxmail"

//starred mail
export const GET_STARRED_MAILS = "/starredmails"

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails"

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails"

//Send mail
export const GET_SENT_MAILS = "/sentmails"

//Trash mail
export const GET_TRASH_MAILS = "/trashmails"

//CALENDER
export const GET_EVENTS = "/events"
export const ADD_NEW_EVENT = "/add/event"
export const UPDATE_EVENT = "/update/event"
export const DELETE_EVENT = "/delete/event"
export const GET_CATEGORIES = "/categories"

//CHATS
export const GET_CHATS = "/chats"
export const GET_GROUPS = "/groups"
export const GET_CONTACTS = "/contacts"
export const GET_MESSAGES = "/messages"
export const ADD_MESSAGE = "/add/messages"

//ORDERS
export const GET_ORDERS = "/orders"
export const ADD_NEW_ORDER = "/add/order"
export const UPDATE_ORDER = "/update/order"
export const DELETE_ORDER = "/delete/order"

//CART DATA
export const GET_CART_DATA = "/cart"

//CUSTOMERS
export const GET_CUSTOMERS = "/customers"
export const ADD_NEW_CUSTOMER = "/add/customer"
export const UPDATE_CUSTOMER = "/update/customer"
export const DELETE_CUSTOMER = "/delete/customer"

//SHOPS
export const GET_SHOPS = "/shops"

//CRYPTO
export const GET_WALLET = "/wallet"
export const GET_CRYPTO_ORDERS = "/crypto/orders"

//INVOICES
export const GET_INVOICES = "/invoices"
export const GET_INVOICE_DETAIL = "/invoice"

//PROJECTS
export const GET_PROJECTS = "/projects"
export const GET_PROJECT_DETAIL = "/project"
export const ADD_NEW_PROJECT = "/add/project"
export const UPDATE_PROJECT = "/update/project"
export const DELETE_PROJECT = "/delete/project"

//TASKS
export const GET_TASKS = "/tasks"

//CONTACTS
export const GET_USERS = "/users"
export const GET_USER_PROFILE = "/user"
export const ADD_NEW_USER = "/add/user"
export const UPDATE_USER = "/update/user"
export const DELETE_USER = "/delete/user"

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data"
export const GET_YEARLY_DATA = "/yearly-data"
export const GET_MONTHLY_DATA = "/monthly-data"

export const TOP_SELLING_DATA = "/top-selling-data"

export const GET_EARNING_DATA = "/earning-charts-data"

export const GET_PRODUCT_COMMENTS = "/comments-product"

export const ON_LIKNE_COMMENT = "/comments-product-action"

export const ON_ADD_REPLY = "/comments-product-add-reply"

export const ON_ADD_COMMENT = "/comments-product-add-comment"
